<template>
    <modal
      name="noticeUpdatesForm"
      classes="v-modal-sec"
      :min-width="500"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
      <div class="v-modal profile_details_modal update-tracking-details-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Update USCIS Notice</h2>
          <span @click="hideNotice()">
            <em class="material-icons">close</em>
          </span>
        </div>
        <h5 v-if="checkProperty(petition, 'caseNo')" class="sub-title padl20 pt-4 mb-0">Case No: <strong>{{ checkProperty(petition, 'caseNo') }}</strong></h5>
        <div class="receipt_updates pb-5" v-if="checkSectionVal('beneficiary')">
            <h5>USCIS status </h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'category') == 'beneficiary'">
                        <li :key="ind">
                            <div class="list__item">
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected"> 
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                            
                            </div>
                        </li>
                    </template>
                   
                </template>
                
            </ul>
        </div>
        <div class="receipt_updates pt-0 pb-5" v-if="checkSectionVal('ead') && [2].indexOf(checkProperty(petition, 'typeDetails', 'id'))>-1 && checkProperty(petition,'beneficiaryInfo', 'h4EADRequired')">
            <h5>EAD USCIS Status</h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'type') == 'ead'">
                        <li :key="ind">
                            <div class="list__item">
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected">
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                               
                            </div>
                        </li>
                    </template>
                </template>
                
            </ul>
        </div>
        <div class="receipt_updates  pt-0 pb-5" v-if="checkSectionVal('h4')">
            <h5>H4 USCIS Status </h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'type') == 'h4'">
                        <li :key="ind">
                            <div class="list__item">
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected">
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                             
                            </div>
                        </li>
                    </template>
                   
                </template>
                
            </ul>
        </div>
        <div class="receipt_updates pt-0 pb-5" v-if="checkSectionVal('h4ead')">
            <h5>H4 EAD USCIS Status </h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'type') == 'h4ead'">
                        <li :key="ind">
                            <div class="list__item">
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected">
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                  
                            </div>
                        </li>
                    </template>
                   
                </template>
                
            </ul>
        </div>
        <!--  -->
        <form @submit.prevent data-vv-scope="noticeform" class="noticeform" v-if="selectedReturnObj !=null" >
          <div class="form-container pt-0 padlr20 mt-0" @click="usciscNoticesUpdateError=''">
            <div class="divider mb-4 mt-0"></div>
            <div class="vx-row">
                <div class="vx-col md:w-1/2">
                      <div class="form_group">
                        <label class="form_label">Case Status<em>*</em></label>
                      <div class="con-select w-full DT_multiselect">                  
                        <multiselect
                          name="action"
                          v-validate="'required'"
                          v-model="selectedNoticeData.action"
                          :show-labels="false"
                          track-by="id"
                          label="text"
                          @input="clearStatusChangedFields"
                          data-vv-as="Case Status"
                          placeholder="Select Status"
                          :options="uscisstatuslist"
                          :searchable="true"
                          :allow-empty="false"
                          :disabled="false"
                          :key="'action'"
                        ></multiselect>
                      </div>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('noticeform.action')"
                      >{{ errors.first("noticeform.action") }}</span>
                      </div>
                    </div>
                <!-- <selectField :display="true"  @input="clearStatusChangedFields"
                  :required="true" :optionslist="uscisstatuslist" v-model="selectedNoticeData.action" 
                 :formscope="'noticeform'" :fieldName="'action'" label="Case Status" placeHolder="Case Status" /> -->

                 <selectField :display="true" :listContainsId="false"
                 :required="true" :optionslist="documentTypes" v-model="selectedNoticeData.documentType" 
                 :formscope="'noticeform'" :fieldName="'documentType'" label="Document Type" placeHolder="Document Type" />
                 

                <datepickerField  :display="true"  :validationRequired="true"  v-if="checkProperty(selectedNoticeData ,'action', 'value') =='USCIS_RECEIVED_RFE'"
                v-model="selectedNoticeData.issuedDate" formscope="noticeform" :dateEnableTo="new Date()"  @input="updateRfeIssuedDate($event)"
                :fieldName="'issuedDate'"  label="RFE Issued Date" />

                <datepickerField  :display="true"  :validationRequired="true" :dateEnableFrom="selectedNoticeData.issuedDate"
                v-model="selectedNoticeData.receivedDate" formscope="noticeform" :dateEnableTo="new Date()"  
                :isDisabled="selectedNoticeData.issuedDate == null && checkProperty(selectedNoticeData ,'action', 'value') =='USCIS_RECEIVED_RFE'"
                :fieldName="'receivedDate'"  label="Received Date" />

                <datepickerField  :display="true"  :validationRequired="true"  v-if="checkProperty(selectedNoticeData ,'action', 'value') =='USCIS_RECEIVED_RFE'"
                v-model="selectedNoticeData.dueDate" formscope="noticeform" :dateEnableTo="new Date()"   :dateEnableFrom="selectedNoticeData.issuedDate"
                :isDisabled="selectedNoticeData.issuedDate == null && checkProperty(selectedNoticeData ,'action', 'value') =='USCIS_RECEIVED_RFE'"
                :fieldName="'dueDate'"  label="RFE Due Date" />

                <div class="vx-col w-full">
                    <div class="form_group">
                        <label class="form_label">Comments<em>*</em></label>
                        <ckeditor  data-vv-as="Comments"
                            v-validate="'required'"
                            v-model="selectedNoticeData.description"
                            name="description"
                            class="w-full" :editor="editor" :config="editorConfig"></ckeditor>
                        <span
                        class="text-danger text-sm"
                        v-show="errors.has('noticeform.description')"
                        >* Comments are required</span>
                    </div>
                </div>

            </div>
          </div>
            <div @click="usciscNoticesUpdateError=''" class="text-danger text-sm formerrors" v-if="usciscNoticesUpdateError!=''">
                <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ usciscNoticesUpdateError }}</vs-alert>
            </div>
          <div class="popup-footer relative" >
            <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif"></span>
            <vs-button color="dark"  class="cancel" type="filled" @click="hideNotice()">Cancel</vs-button>
            <vs-button  color="success" class="save" type="filled" @click="submitForm()">Submit</vs-button>
          </div>
        </form>
      </div>
    </modal>
  </template>
  <script>
  import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import moment from "moment";
  import { EyeIcon } from "vue-feather-icons";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import * as _ from "lodash";
  
  export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {
      EyeIcon,
      immiInput,
      datepickerField,
      selectField
    },
    methods:{
        updateRfeIssuedDate(val){
            if(val){
                if(this.selectedNoticeData.receivedDate){
                    let startData = moment(val);
                    let endData= moment(this.selectedNoticeData.receivedDate)
                    if(startData.isAfter(endData , 'day')){
                        this.selectedNoticeData.receivedDate = null
                    }
                }
                if(this.selectedNoticeData.dueDate){
                    let startDate = moment(val);
                    let endDate= moment(this.selectedNoticeData.dueDate)
                    if(startDate.isAfter(endDate , 'day')){
                        this.selectedNoticeData.dueDate = null
                    }
                }
            }else{
                this.selectedNoticeData.dueDate = null
                this.selectedNoticeData.receivedDate= null
            }
        },
        clearStatusChangedFields(){
            console.log('clearStatusChangedFields')
            this.selectedNoticeData.receivedDate = null
            this.selectedNoticeData.dueDate = null
            this.selectedNoticeData.issuedDate = null
            this.selectedNoticeData.description =''
            this.selectedNoticeData.documentType = null
        },
        clearSelected(tr){
            let self = this;
            if(this.checkProperty(tr ,'isSelected') &&  this.checkProperty(this.receiptDataList,'length')>0 ){
                //this.selectedReturnObj = null;
                _.forEach(this.receiptDataList,(item) => {
                    if(((item['type'] == self.checkProperty(tr,'type')) && (item['category'] == self.checkProperty(tr,'category')) && !self.checkProperty(tr,'childrenId')) ||
                     (self.checkProperty(tr,'childrenId') && item['childrenId'] == self.checkProperty(tr,'childrenId') ) ){
                       
                    }else{
                        item['isSelected'] = false;
                    }
                })
            }
            this.returnSelectedObj();
            
        },
        getReceiptData(){
            let receiptList = [];
            let self = this;
            this.spouseExists = false;
            if(this.petition){
                if(this.checkProperty(this.petition, 'beneficiaryInfo', 'name')){
                    let objBen = {
                        name:this.checkProperty(this.petition, 'beneficiaryInfo', 'name'),
                        subTitle:'beneficiary',
                        type:'beneficiary',
                        category:'beneficiary',
                        isSelected:false,
                        action:null,
                        description:'',
                        isAlreadyUpdated:false,
                        receivedDate:null,
                        issuedDate:null,
                        dueDate:null,
                        documentType:null,
                    }
                    let tempBenficiaryFinalLog = [];
                    if(this.checkProperty(this.petition, 'uscisUpdateCategories') && this.petition.uscisUpdateCategories.indexOf('beneficairy')>-1 && this.checkProperty(this.caseCurrentDetails, 'length') >0){
                        _.forEach(this.caseCurrentDetails,(item)=>{
                            if(['UPDATE_USCIS_RESPONSE' ].indexOf(item['action']) >-1  ){
                                if(_.has(item ,'endedOn') && item['endedOn'] && !this.checkProperty(item ,'ignore')){               
                                    if(_.has(item ,'endedOn') && item['endedOn']){
                                        item['endedOn'] = moment(item['endedOn'])
                                    }
                                    if(_.has(item ,'startedOn') && item['startedOn']){
                                        item['startedOn'] = moment(item['startedOn'])
                                    }
                                    if(this.checkProperty( item,'data' ,'rfeNotice')){
                                        if( this.checkProperty(item, 'data','userCatergoryCode') =='beneficairy'){
                                            let tempRfeDocs = null;
                                            let benRFEdata = null;
                                            if(this.petition && this.checkProperty(this.petition,'rfeNotice') && this.checkProperty(this.petition['rfeNotice'], 'documents') && this.checkProperty(this.petition['rfeNotice'], 'documents', 'length')>0){
                                                tempRfeDocs =  this.checkProperty(this.petition['rfeNotice'], 'documents')
                                            }
                                                benRFEdata = this.checkProperty(this.petition, 'rfeNotice')
                                            if(_.has(item,'data') && _.has(item['data'],'rfeNotice') && _.has(item['data']['rfeNotice'],'documents')
                                            && this.checkProperty(item['data']['rfeNotice'],'documents') && this.checkProperty(item['data']['rfeNotice'],'documents', 'length')>0){
                                                tempBenficiaryFinalLog.push(item);
                                            }else if(tempRfeDocs  && this.checkProperty(tempRfeDocs, 'length')>0){
                                                item['data']['rfeNotice']['documents'] = tempRfeDocs;
                                                if(benRFEdata && this.checkProperty(benRFEdata,'receivedDate') && !this.checkProperty(item['data']['rfeNotice'],'receivedDate')  ){
                                                    item['data']['rfeNotice']['receivedDate'] = benRFEdata['receivedDate'];
                                                }
                                                if(benRFEdata && this.checkProperty(benRFEdata,'dueDate') && !this.checkProperty(item['data']['rfeNotice'],'dueDate')  ){
                                                    item['data']['rfeNotice']['dueDate'] = benRFEdata['dueDate'];
                                                }
                                                if(benRFEdata && this.checkProperty(benRFEdata,'issuedDate') && !this.checkProperty(item['data']['rfeNotice'],'issuedDate')  ){
                                                    item['data']['rfeNotice']['issuedDate'] = benRFEdata['issuedDate'];
                                                }
                                                tempBenficiaryFinalLog.push(item);
                                            }else{
                                                tempBenficiaryFinalLog.push(item);
                                            }
                                        }
                                    }
                                }
                            }
                        })
                        if(tempBenficiaryFinalLog.length>0){
                            tempBenficiaryFinalLog  = _.orderBy(tempBenficiaryFinalLog ,['endedOn'] ,["desc",'desc'] );
                            let benObj = tempBenficiaryFinalLog[0];
                            if(benObj && benObj['data'] && benObj['data']['rfeNotice']){
                                if(benObj['data']['rfeNotice']['action']){
                                    let action = benObj['data']['rfeNotice']['action'];
                                    if(this.checkRFECase && action){
                                        action = action.replace('RFE_', '')
                                    }
                                    objBen['action'] = _.find(this.uscisstatuslist ,{"value":action});
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'receivedDate')){
                                    objBen['receivedDate'] = benObj['data']['rfeNotice']['receivedDate']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'issuedDate')){
                                    objBen['issuedDate'] = benObj['data']['rfeNotice']['issuedDate']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'dueDate')){
                                    objBen['dueDate'] = benObj['data']['rfeNotice']['dueDate']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'description')){
                                    objBen['description'] = benObj['data']['rfeNotice']['description']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'documentType')){
                                    objBen['documentType'] = benObj['data']['rfeNotice']['documentType']
                                }
                                objBen['isAlreadyUpdated'] = true; 
                            }
                        }
                    }
                    receiptList.push(objBen);
                    
                }
            }
            if(this.petition && [2].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1 && this.checkProperty(this.petition,'beneficiaryInfo', 'h4EADRequired')  ){
                if(this.checkProperty(this.petition, 'beneficiaryInfo', 'name')){
                    let objBenEad = {
                        name:this.checkProperty(this.petition, 'beneficiaryInfo', 'name'),
                        subTitle:'beneficiary',
                        type:'ead',
                        category:'beneficiary',
                        isSelected:false,
                        action:null,
                        description:'',
                        isAlreadyUpdated:false,
                        receivedDate:null,
                        issuedDate:null,
                        dueDate:null,
                        documentType:null,
                    }
                    let tempBenficiaryFinalLog = [];
                    if(this.checkProperty(this.petition, 'uscisUpdateCategories') && this.petition.uscisUpdateCategories.indexOf('beneficairy_ead')>-1 && this.checkProperty(this.caseCurrentDetails, 'length') >0){
                        _.forEach(this.caseCurrentDetails,(item)=>{
                            if(['UPDATE_USCIS_RESPONSE' ].indexOf(item['action']) >-1  ){
                                if(_.has(item ,'endedOn') && item['endedOn'] && !this.checkProperty(item ,'ignore')){               
                                    if(_.has(item ,'endedOn') && item['endedOn']){
                                        item['endedOn'] = moment(item['endedOn'])
                                    }
                                    if(_.has(item ,'startedOn') && item['startedOn']){
                                        item['startedOn'] = moment(item['startedOn'])
                                    }
                                    if(this.checkProperty( item,'data' ,'rfeNotice')){
                                        if( this.checkProperty(item, 'data','uscisUpdateCategory') =='ead'){
                                            let tempRfeDocs = null;
                                            let benRFEdata = null;
                                            if(this.petition && this.checkProperty(this.petition,'benfEadRfeNotices') && this.checkProperty(this.petition['benfEadRfeNotices'], 'documents') && this.checkProperty(this.petition['benfEadRfeNotices'], 'documents', 'length')>0){
                                                tempRfeDocs =  this.checkProperty(this.petition['benfEadRfeNotices'], 'documents')
                                            }
                                                benRFEdata = this.checkProperty(this.petition, 'benfEadRfeNotices')
                                            if(_.has(item,'data') && _.has(item['data'],'rfeNotice') && _.has(item['data']['rfeNotice'],'documents')
                                            && this.checkProperty(item['data']['rfeNotice'],'documents') && this.checkProperty(item['data']['rfeNotice'],'documents', 'length')>0){
                                                tempBenficiaryFinalLog.push(item);
                                            }else if(tempRfeDocs  && this.checkProperty(tempRfeDocs, 'length')>0){
                                                item['data']['rfeNotice']['documents'] = tempRfeDocs;
                                                if(benRFEdata && this.checkProperty(benRFEdata,'receivedDate') && !this.checkProperty(item['data']['rfeNotice'],'receivedDate')  ){
                                                    item['data']['rfeNotice']['receivedDate'] = benRFEdata['receivedDate'];
                                                }
                                                if(benRFEdata && this.checkProperty(benRFEdata,'dueDate') && !this.checkProperty(item['data']['rfeNotice'],'dueDate')  ){
                                                    item['data']['rfeNotice']['dueDate'] = benRFEdata['dueDate'];
                                                }
                                                if(benRFEdata && this.checkProperty(benRFEdata,'issuedDate') && !this.checkProperty(item['data']['rfeNotice'],'issuedDate')  ){
                                                    item['data']['rfeNotice']['issuedDate'] = benRFEdata['issuedDate'];
                                                }
                                                tempBenficiaryFinalLog.push(item);
                                            }else{
                                                tempBenficiaryFinalLog.push(item);
                                            }
                                        }
                                    }
                                }
                            }
                        })
                        if(tempBenficiaryFinalLog.length>0){
                            tempBenficiaryFinalLog  = _.orderBy(tempBenficiaryFinalLog ,['endedOn'] ,["desc",'desc'] );
                            let benObj = tempBenficiaryFinalLog[0];
                            if(benObj && benObj['data'] && benObj['data']['rfeNotice'] && benObj['data']['rfeNotice']['userType'] == 'ead'){
                                if(benObj['data']['rfeNotice']['action']){
                                    let action = benObj['data']['rfeNotice']['action'];
                                    if(this.checkRFECase && action){
                                        action = action.replace('RFE_', '')
                                    }
                                    objBenEad['action'] = _.find(this.uscisstatuslist ,{"value":action});
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'receivedDate')){
                                    objBenEad['receivedDate'] = benObj['data']['rfeNotice']['receivedDate']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'issuedDate')){
                                    objBenEad['issuedDate'] = benObj['data']['rfeNotice']['issuedDate']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'dueDate')){
                                    objBenEad['dueDate'] = benObj['data']['rfeNotice']['dueDate']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'description')){
                                    objBenEad['description'] = benObj['data']['rfeNotice']['description']
                                }
                                if(this.checkProperty(benObj['data']['rfeNotice'], 'documentType')){
                                    objBenEad['documentType'] = benObj['data']['rfeNotice']['documentType']
                                }
                                objBenEad['isAlreadyUpdated'] = true; 
                            }
                        }
                    }
                    receiptList.push(objBenEad);
                }
            }
            if(this.checkProperty(this.petition ,'beneficiaryInfo' ,'maritalStatus') && this.checkProperty(this.petition ,'beneficiaryInfo' ,'maritalStatus') !=1){
                if(this.checkProperty(this.petition ,'dependentsInfo' ,'spouse') && ((this.isH1bCase &&this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'h4Required')) || 
                (this.isL1Case &&this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'l2Required')) || (this.isL2Case &&this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'hasSpouse'))
                    || (this.isH4Case && this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'hasSpouse'))) ){
                    if(this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name')){
                       let objSpouse = {
                            name:this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name'),
                            subTitle:'spouse',
                            type:'h4',
                            category:'spouse',
                            isSelected:false,
                            action:null,
                            description:'',
                            isAlreadyUpdated:false,
                            receivedDate:null,
                            issuedDate:null,
                            dueDate:null,
                            documentType:null,
                        }
                        if(this.checkProperty(this.petition, 'uscisUpdateCategories') && this.petition.uscisUpdateCategories.indexOf('h4_spouse')>-1 && this.checkProperty(this.caseCurrentDetails, 'length') >0){
                            let h4Spouse=[];
                            _.forEach(this.caseCurrentDetails,(item)=>{
                                if(['UPDATE_USCIS_RESPONSE' ].indexOf(item['action']) >-1){
                                    if(_.has(item ,'endedOn') && item['endedOn'] && !this.checkProperty(item ,'ignore')){
                                        if(_.has(item ,'endedOn') && item['endedOn']){
                                            item['endedOn'] = moment(item['endedOn'])
                                        }
                                        if(_.has(item ,'startedOn') && item['startedOn']){
                                            item['startedOn'] = moment(item['startedOn'])
                                        }
                                        if(self.checkProperty( item,'data' ,'rfeNotice')){
                                            if(self.checkProperty( item['data'],'uscisUpdateCategory') =='h4'){
                                                let h4RFEspouseDocs = null;
                                                if(self.petition && self.checkProperty(self.petition,'h4RfeNotices') && self.checkProperty(self.petition,'h4RfeNotices', 'length')>0){
                                                    h4RFEspouseDocs =  _.find(self.petition['h4RfeNotices'], (obj)=>{ return self.checkProperty(obj,'userType') =="spouse" });
                                                }
                                                if(self.checkProperty(item,'data', "userCatergoryCode" ) !="h4_children"){
                                                    if(_.has(item,'data') && _.has(item['data'],'rfeNotice') && _.has(item['data']['rfeNotice'],'documents')
                                                    && this.checkProperty(item['data']['rfeNotice'],'documents') && this.checkProperty(item['data']['rfeNotice'],'documents', 'length')>0){
                                                        h4Spouse.push(item);
                                                    }else if(h4RFEspouseDocs && self.checkProperty(h4RFEspouseDocs,'documents') && self.checkProperty(h4RFEspouseDocs,'documents', 'length')>0){
                                                        item['data']['rfeNotice']['documents'] = h4RFEspouseDocs['documents'];
                                                        if(h4RFEspouseDocs && self.checkProperty(h4RFEspouseDocs,'receivedDate') && !self.checkProperty(item['data']['rfeNotice'],'receivedDate')  ){
                                                            item['data']['rfeNotice']['receivedDate'] = h4RFEspouseDocs['receivedDate'];
                                                        }
                                                        if(h4RFEspouseDocs && self.checkProperty(h4RFEspouseDocs,'dueDate') && !self.checkProperty(item['data']['rfeNotice'],'dueDate')  ){
                                                            item['data']['rfeNotice']['dueDate'] = h4RFEspouseDocs['dueDate'];
                                                        }
                                                        if(h4RFEspouseDocs && self.checkProperty(h4RFEspouseDocs,'issuedDate') && !self.checkProperty(item['data']['rfeNotice'],'issuedDate')  ){
                                                            item['data']['rfeNotice']['issuedDate'] = h4RFEspouseDocs['issuedDate'];
                                                        }
                                                        h4Spouse.push(item);
                                                    }else{
                                                        h4Spouse.push(item);
                                                    }
                                                } 
                                            }
                                        }
                                    }
                                }
                            });
                            if(h4Spouse && h4Spouse.length>0){
                                h4Spouse  = _.orderBy(h4Spouse, ["data.rfeNotice.userType",'endedOn' ] ,["desc",'desc'] );
                                let h4SpouseObj = h4Spouse[0];
                                if(h4SpouseObj && h4SpouseObj['data'] && h4SpouseObj['data']['rfeNotice'] && h4SpouseObj['data']['rfeNotice']['userType'] == 'spouse'){
                                    if(h4SpouseObj['data']['rfeNotice']['action']){ 
                                        objSpouse.action = _.find(this.uscisstatuslist ,{"value":h4SpouseObj['data']['rfeNotice']['action']});
                                    }
                                    if(this.checkProperty(h4SpouseObj['data']['rfeNotice'], 'issuedDate')){
                                        objSpouse.issuedDate = h4SpouseObj['data']['rfeNotice']['issuedDate'];
                                    }
                                    if(this.checkProperty(h4SpouseObj['data']['rfeNotice'], 'receivedDate')){
                                        objSpouse.receivedDate = h4SpouseObj['data']['rfeNotice']['receivedDate'];
                                    }
                                    if(this.checkProperty(h4SpouseObj['data']['rfeNotice'], 'dueDate')){
                                        objSpouse.dueDate = h4SpouseObj['data']['rfeNotice']['dueDate'];
                                    }
                                    if(this.checkProperty(h4SpouseObj['data']['rfeNotice'], 'documentType')){
                                        objSpouse.documentType = h4SpouseObj['data']['rfeNotice']['documentType'];
                                    }
                                    if(this.checkProperty(h4SpouseObj['data']['rfeNotice'], 'description')){
                                        objSpouse.description = h4SpouseObj['data']['rfeNotice']['description'];
                                    }
                                    objSpouse['isAlreadyUpdated'] = true; 
                                }
                            }
                        }
                        this.spouseExists = true;
                        receiptList.push(objSpouse);
                    }
                }
                if(this.checkProperty(this.petition ,'dependentsInfo' ,'spouse') && (this.isH1bCase && this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'h4EADRequired'))  ){
                    if(this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name')){
                        let objSpouseEad = {
                            name:this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name'),
                            subTitle:'spouse',
                            type:'h4ead',
                            category:'spouse',
                            childrenId:'',
                            isSelected:false,
                            action:null,
                            isAlreadyUpdated:false,
                            receivedDate:null,
                            issuedDate:null,
                            dueDate:null,
                            documentType:null,
                            description:'',
                        }
                        if(this.checkProperty(this.petition, 'uscisUpdateCategories') && this.petition.uscisUpdateCategories.indexOf('h4ead_spouse')>-1 && this.checkProperty(this.caseCurrentDetails, 'length') >0){
                            let h4EadLogs = [];
                            _.forEach(this.caseCurrentDetails,(item)=>{
                                if(['UPDATE_USCIS_RESPONSE' ].indexOf(item['action']) >-1){
                                    if(_.has(item ,'endedOn') && item['endedOn'] && !this.checkProperty(item ,'ignore')){
                                        if(_.has(item ,'endedOn') && item['endedOn']){
                                            item['endedOn'] = moment(item['endedOn'])
                                        }
                                        if(_.has(item ,'startedOn') && item['startedOn']){
                                            item['startedOn'] = moment(item['startedOn'])
                                        }
                                        if(this.checkProperty( item,'data' ,'rfeNotice')){
                                        let h4EADRFEspouseDocs = null;
                                        if(this.petition && this.checkProperty(this.petition,'h4EadRfeNotices') && this.checkProperty(this.petition,'h4EadRfeNotices', 'length')>0){
                                                    h4EADRFEspouseDocs =  _.find(this.petition['h4EadRfeNotices'], (obj)=>{ return this.checkProperty(obj,'userType') =="spouse" });
                                            }
                                            if(this.checkProperty( item['data'],'uscisUpdateCategory') =='h4ead'){
                                            if(_.has(item,'data') && _.has(item['data'],'rfeNotice') && _.has(item['data']['rfeNotice'],'documents')
                                            && this.checkProperty(item['data']['rfeNotice'],'documents') && this.checkProperty(item['data']['rfeNotice'],'documents', 'length')>0){
                                                h4EadLogs.push(item);
                                            }else if(h4EADRFEspouseDocs && this.checkProperty(h4EADRFEspouseDocs,'documents') && this.checkProperty(h4EADRFEspouseDocs,'documents', 'length')>0){
                                                item['data']['rfeNotice']['documents'] = h4EADRFEspouseDocs['documents'];
                                                if(h4EADRFEspouseDocs && this.checkProperty(h4EADRFEspouseDocs,'receivedDate') && !this.checkProperty(item['data']['rfeNotice'],'receivedDate')  ){
                                                    item['data']['rfeNotice']['receivedDate'] = h4EADRFEspouseDocs['receivedDate'];
                                                }
                                                if(h4EADRFEspouseDocs && this.checkProperty(h4EADRFEspouseDocs,'dueDate') && !this.checkProperty(item['data']['rfeNotice'],'dueDate')  ){
                                                    item['data']['rfeNotice']['dueDate'] = h4EADRFEspouseDocs['dueDate'];
                                                }
                                                if(h4EADRFEspouseDocs && this.checkProperty(h4EADRFEspouseDocs,'issuedDate') && !this.checkProperty(item['data']['rfeNotice'],'issuedDate')  ){
                                                    item['data']['rfeNotice']['issuedDate'] = h4EADRFEspouseDocs['issuedDate'];
                                                }
                                                h4EadLogs.push(item);
                                            }else{
                                                h4EadLogs.push(item);
                                            }
                                            }
                                        }
                                    }
                                }
                            } );
                            if(h4EadLogs && h4EadLogs.length>0){
                                h4EadLogs  = _.orderBy(h4EadLogs, ["data.rfeNotice.userType",'endedOn' ] ,["desc",'desc'] );
                                let h4EadObj = h4EadLogs[0];
                                if(h4EadObj && h4EadObj['data'] && h4EadObj['data']['rfeNotice'] && h4EadObj['data']['rfeNotice']['userType'] == 'spouse'){
                                    if(h4EadObj['data']['rfeNotice']['action']){ 
                                        objSpouseEad.action = _.find(this.uscisstatuslist ,{"value":h4EadObj['data']['rfeNotice']['action']});
                                        //this.disabledh4EADSpouseStatus =true;
                                    }
                                    if(this.checkProperty(h4EadObj['data']['rfeNotice'], 'issuedDate')){
                                        objSpouseEad.issuedDate = h4EadObj['data']['rfeNotice']['issuedDate'];
                                    }
                                    if(this.checkProperty(h4EadObj['data']['rfeNotice'], 'receivedDate')){
                                        objSpouseEad.receivedDate = h4EadObj['data']['rfeNotice']['receivedDate'];
                                    }
                                    if(this.checkProperty(h4EadObj['data']['rfeNotice'], 'dueDate')){
                                        objSpouseEad.dueDate = h4EadObj['data']['rfeNotice']['dueDate'];
                                    }
                                    if(this.checkProperty(h4EadObj['data']['rfeNotice'], 'documentType')){
                                        objSpouseEad.documentType = h4EadObj['data']['rfeNotice']['documentType'];
                                    }
                                    if(this.checkProperty(h4EadObj['data']['rfeNotice'], 'description')){
                                        objSpouseEad.description = h4EadObj['data']['rfeNotice']['description'];
                                    }
                                    objSpouseEad['isAlreadyUpdated'] = true; 
                                }
                            }
                        }
                        receiptList.push(objSpouseEad);
                    }
                }
                if(this.checkProperty(this.petition ,'dependentsInfo' ,'childrens') && this.checkProperty(this.petition['dependentsInfo'] ,'childrens', 'length')>0){
                    let h4Exists = _.find(this.petition['dependentsInfo']['childrens'], {'h4Required':true});
                    let l2Exists = _.find(this.petition['dependentsInfo']['childrens'], {'l2Required':true});
                    let childExists = _.find(this.petition['dependentsInfo']['childrens'], {'hasChildren':true});
                    if((this.isH1bCase && h4Exists) || (this.isL1Case && l2Exists) || 
                    (this.isL2Case && childExists) || (this.isH4Case && childExists)){
                        let childObj = {
                            name:'Children',
                            subTitle:'children',
                            type:'h4',
                            category:'children',
                            //childrenId:this.checkProperty(childItem, '_id'),
                            isSelected:false,
                            action:null,
                            isAlreadyUpdated:false,
                            receivedDate:null,
                            issuedDate:null,
                            dueDate:null,
                            documentType:null,
                            description:'',
                        }
                        if(this.checkProperty(this.petition, 'uscisUpdateCategories') && this.petition.uscisUpdateCategories.indexOf('h4_children')>-1 && this.checkProperty(this.caseCurrentDetails, 'length') >0){
                            let h4Child = [];
                            _.forEach(this.caseCurrentDetails,(item)=>{
                                if(['UPDATE_USCIS_RESPONSE' ].indexOf(item['action']) >-1){
                                    if(_.has(item ,'endedOn') && item['endedOn'] && !this.checkProperty(item ,'ignore')){
                                    if(_.has(item ,'endedOn') && item['endedOn']){
                                        item['endedOn'] = moment(item['endedOn'])
                                    }
                                    if(_.has(item ,'startedOn') && item['startedOn']){
                                        item['startedOn'] = moment(item['startedOn'])
                                    }
                                    if(this.checkProperty( item,'data' ,'rfeNotice')){
                                        if(this.checkProperty( item['data'],'uscisUpdateCategory') =='h4' &&  this.checkProperty(item,'data', "userCatergoryCode" ) =="h4_children"){
                                            
                                            let ischildrenExists = _.find(h4Child, (obj)=>{ return this.checkProperty(obj,'data', "userCatergoryCode" ) =="h4_children" });
                                            let h4RFEchildDocs = null;
                                        
                                            if(this.petition && this.checkProperty(this.petition,'h4RfeNotices') && this.checkProperty(this.petition,'h4RfeNotices', 'length')>0){
                                                h4RFEchildDocs = _.find(this.petition['h4RfeNotices'], (obj)=>{ return this.checkProperty(obj,'userType') =="children" });
                                            }
                                            if(this.checkProperty(item,'data', "userCatergoryCode" ) =="h4_children"){
                                            if( !ischildrenExists || true){
                                                if(_.has(item,'data') && _.has(item['data'],'rfeNotice') && _.has(item['data']['rfeNotice'],'documents')
                                                && this.checkProperty(item['data']['rfeNotice'],'documents') && this.checkProperty(item['data']['rfeNotice'],'documents', 'length')>0){
                                                    h4Child.push(item);
                                                }else if(h4RFEchildDocs && this.checkProperty(h4RFEchildDocs,'documents') && this.checkProperty(h4RFEchildDocs,'documents', 'length')>0){
                                                    item['data']['rfeNotice']['documents'] = h4RFEchildDocs['documents'];
                                                    if(h4RFEchildDocs && this.checkProperty(h4RFEchildDocs,'receivedDate') && !this.checkProperty(item['data']['rfeNotice'],'receivedDate')  ){
                                                        item['data']['rfeNotice']['receivedDate'] = h4RFEchildDocs['receivedDate'];
                                                    }
                                                    if(h4RFEchildDocs && this.checkProperty(h4RFEchildDocs,'dueDate') && !this.checkProperty(item['data']['rfeNotice'],'dueDate')  ){
                                                        item['data']['rfeNotice']['dueDate'] = h4RFEchildDocs['dueDate'];
                                                    }
                                                    if(h4RFEchildDocs && this.checkProperty(h4RFEchildDocs,'issuedDate') && !this.checkProperty(item['data']['rfeNotice'],'issuedDate')  ){
                                                        item['data']['rfeNotice']['issuedDate'] = h4RFEchildDocs['issuedDate'];
                                                    }
                                                    h4Child.push(item);
                                                }else{
                                                    h4Child.push(item);
                                                }
                                            }
                                            } 
                                        }
                                    }
                                    }
                                }
                            });
                            if(h4Child && h4Child.length>0){
                                h4Child  = _.orderBy(h4Child, ["data.rfeNotice.userType",'endedOn' ] ,["desc",'desc'] );
                                let h4ChildObj = h4Child[0];
                                if(h4ChildObj && h4ChildObj['data'] && h4ChildObj['data']['rfeNotice'] && h4ChildObj['data']['rfeNotice']['userType'] == 'children'){
                                    if(h4ChildObj['data']['rfeNotice']['action']){ 
                                        childObj.action = _.find(this.uscisstatuslist ,{"value":h4ChildObj['data']['rfeNotice']['action']});
                                    }
                                    if(this.checkProperty(h4ChildObj['data']['rfeNotice'], 'issuedDate')){
                                        childObj.issuedDate = h4ChildObj['data']['rfeNotice']['issuedDate'];
                                    }
                                    if(this.checkProperty(h4ChildObj['data']['rfeNotice'], 'receivedDate')){
                                        childObj.receivedDate = h4ChildObj['data']['rfeNotice']['receivedDate'];
                                    }
                                    if(this.checkProperty(h4ChildObj['data']['rfeNotice'], 'dueDate')){
                                        childObj.dueDate = h4ChildObj['data']['rfeNotice']['dueDate'];
                                    }
                                    if(this.checkProperty(h4ChildObj['data']['rfeNotice'], 'documentType')){
                                        childObj.documentType = h4ChildObj['data']['rfeNotice']['documentType'];
                                    }
                                    if(this.checkProperty(h4ChildObj['data']['rfeNotice'], 'description')){
                                        childObj.description = h4ChildObj['data']['rfeNotice']['description'];
                                    }
                                }
                            }
                        }
                        receiptList.push(childObj);
                    }
                }
            }
            if(receiptList && receiptList.length>0){
                this.receiptDataList = receiptList;
            }
        },
        hideNotice(callFromSuccess = false) {
            this.$modal.hide('noticeUpdatesForm')
            this.$emit("hideNotice", callFromSuccess);
        },
        getNoticeDocName(data){
            let selectedData = data;
            let fileNames = [];
            if(this.checkProperty(selectedData, 'documents', 'length')>0){
                let documents =  this.checkProperty(selectedData, 'documents')
                if(this.selectedCategory == 'beneficiary'){
                    if(this.checkProperty(selectedData, 'userName')){
                        fileNames.push(this.checkProperty(selectedData, 'userName'))
                    }
                    if(this.companyName != ''){
                        fileNames.push(this.companyName)
                    }
                    fileNames.push('I-129');
                    if(this.checkProperty(selectedData,'action','value') == 'USCIS_APPROVED'){
                        fileNames.push('Approval Notice.pdf');
                    }
                    else if(this.checkProperty(selectedData,'action','value') == 'USCIS_DENIED'){
                        fileNames.push('Decision.pdf');
                    }
                    else if(this.checkProperty(selectedData,'action','value') == 'USCIS_RECEIVED_RFE'){
                        fileNames.push('RFE Notice.pdf');
                    }
                    else if(this.checkProperty(selectedData,'action','value') == 'USCIS_WITHDRAWN'){
                        fileNames.push('Withdrawal.pdf');
                    }else{
                        fileNames.push('Notice.pdf');
                    }
                }else if(this.selectedCategory != 'beneficiary'){
                    if(this.checkProperty(selectedData, 'userName')){
                        fileNames.push(this.checkProperty(selectedData, 'userName'))
                    }
                    if(this.companyName != ''){
                        fileNames.push(this.companyName)
                    }
                    if(this.selectedCategory == 'h4'){
                        if(this.checkProperty(selectedData, 'userType') == 'spouse'){ 
                            fileNames.push('I-539');
                        }
                        if(this.checkProperty(selectedData, 'userType') == 'children'){ 
                            if(this.spouseExists){
                                fileNames.push('I-539A');
                            }else{
                                fileNames.push('I-539');
                            }
                        }
                    }
                    if(this.selectedCategory == 'h4ead'){
                        fileNames.push('I-765');
                    }
                    if(this.checkProperty(selectedData,'action','value') == 'USCIS_APPROVED'){
                        fileNames.push('Approval Notice.pdf');
                    }
                    else if(this.checkProperty(selectedData,'action','value') == 'USCIS_DENIED'){
                        fileNames.push('Decision.pdf');
                    }
                    else if(this.checkProperty(selectedData,'action','value') == 'USCIS_RECEIVED_RFE'){
                        fileNames.push('RFE Notice.pdf');
                    }
                    else if(this.checkProperty(selectedData,'action','value') == 'USCIS_WITHDRAWN'){
                        fileNames.push('Withdrawal.pdf');
                    }else{
                        fileNames.push('Notice.pdf');
                    }
                }
                if(fileNames && this.checkProperty(fileNames, 'length')>0 ){
                    documents[0].name = fileNames.join('_');
                }
                return documents;
            }else{
                return this.checkProperty(selectedData, 'documents');
            }
        },
        submitForm(){
            this.$validator.validateAll("noticeform").then((result) => {
                this.usciscNoticesUpdateError ='';
                if(result){ 
                    let path = '/petition/manage-approval-process-h4-h4ead';
                   
                    let payLoad = {
                        petitionId:this.checkProperty(this.petition, '_id'),
                        typeId: this.checkProperty(this.petition,'typeDetails','id' ),
                        typeName:this.checkProperty(this.petition,'typeDetails','name' ),
                        subTypeId:this.checkProperty(this.petition,'subTypeDetails','id' ), 
                        subTypeName:this.checkProperty(this.petition,'subTypeDetails','name' ),
                        aiReqCronId:this.aiReqCronId,
                        linkFromAiTools:true,
                    }
                    let action = this.checkProperty(this.selectedNoticeData,'action','value' );
                    if(this.selectedCategory == 'beneficiary'){ 
                        payLoad['action'] = action; 
                        payLoad['receivedDate'] = this.checkProperty(this.selectedNoticeData,'receivedDate');
                        payLoad['issuedDate'] = this.checkProperty(this.selectedNoticeData,'issuedDate');
                        payLoad['dueDate'] = this.checkProperty(this.selectedNoticeData,'dueDate');
                        payLoad['description'] = this.checkProperty(this.selectedNoticeData,'description');
                        payLoad['documentType'] = this.checkProperty(this.selectedNoticeData,'documentType');
                        payLoad['documents'] = this.getNoticeDocName(this.selectedNoticeData)
                        path = '/petition/manage-approval-process';
                    } 
                    if(this.selectedCategory != 'beneficiary' ){
                        payLoad['category'] = this.selectedCategory;
                        payLoad['items'] = [];
                        let py={
                            userType:this.checkProperty(this.selectedNoticeData,'userType'),
                            userName:this.checkProperty(this.selectedNoticeData,'userName'),
                            action:this.checkProperty(this.selectedNoticeData,'action','value' ),
                            description:this.checkProperty(this.selectedNoticeData,'description'),
                            receivedDate:this.checkProperty(this.selectedNoticeData,'receivedDate'),
                            issuedDate:this.checkProperty(this.selectedNoticeData,'issuedDate'),
                            dueDate:this.checkProperty(this.selectedNoticeData,'dueDate'),
                            documentType:this.checkProperty(this.selectedNoticeData,'documentType'),
                            documents:this.getNoticeDocName(this.selectedNoticeData)
                        }
                        if(py['documents'] && this.checkProperty(py['documents'], 'length')>0){
                            let doc = py['documents'][0];
                            Object.assign(doc,
                            {'userType':this.checkProperty(this.selectedNoticeData,'userType'),
                            'userName':this.checkProperty(this.selectedNoticeData,'userName')})
                            py['documents'][0] = doc
                            
                        }
                        payLoad['items'].push(py);
                    }
                    if(this.isAlreadyUpdated){
                        payLoad['uscisReplaceDocs'] = true
                    }
                    this.loading = true;
                    this.$store.dispatch("commonAction", { data: payLoad, path: path }).then((res)=>{
                        this.loading = false;
                        this.showToster({ message:res.message , isError: false})
                        this.hideNotice(true);
                    }).catch((err)=>{
                        this.usciscNoticesUpdateError =err;
                        this.loading = false;
                    })
                }
            })
        },
        returnSelectedObj(){
            let self = this;
            self.loading = false;
            self.usciscNoticesUpdateError ='';
            setTimeout(()=>{
                let obj = {
                    documents:[],
                    userType:'',
                    userName:'',
                    receivedDate:null,
                    issuedDate:null,
                    dueDate:null,
                    action:null,
                    description:''
                } 
                self.selectedReturnObj = null;
                self.isAlreadyUpdated = false;
                self.selectedCategory = '';
                self.selectedNoticeData = obj;
                let returnVal = null;
                returnVal = _.find( self.receiptDataList, {'isSelected':true });
                if(returnVal){
                    
                    if(returnVal['subTitle']){
                        obj['userType'] = returnVal['subTitle']
                    }
                    if(returnVal['name']){
                        obj['userName'] = returnVal['name']
                    }
                    if(self.documentDetail){
                        obj['documents'].push(self.documentDetail)
                    }
                    if(returnVal['receivedDate']){
                        obj['receivedDate'] = returnVal['receivedDate']
                    }
                    if(returnVal['issuedDate']){
                        obj['issuedDate'] = returnVal['issuedDate']
                    }
                    if(returnVal['dueDate']){
                        obj['dueDate'] = returnVal['dueDate']
                    }
                    if(returnVal['action']){
                        obj['action'] = returnVal['action'];
                    }
                    if(returnVal['documentType']){
                        obj['documentType'] = returnVal['documentType']
                    }
                    if(returnVal['description']){
                        obj['description'] = returnVal['description']
                    } 
                    if(returnVal['isAlreadyUpdated']){
                        self.isAlreadyUpdated = true
                    }
                    self.selectedCategory = returnVal['type'];
                    self.selectedNoticeData = obj;
                    
                }
                self.selectedReturnObj = returnVal
            },100)
            //return returnVal
        }
    },
    watch: {
    },
    mounted() {
        if(this.checkProperty(this.petition, 'companyDetails', 'name')){
            this.companyName = this.checkProperty(this.petition, 'companyDetails', 'name')
        }
        if([1].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isH1bCase = true;
        }
        if([2].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isH4Case = true;
        }
        if([5].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isL1Case = true;
        }
        if([11].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isL2Case = true;
        }
        this.getReceiptData();
        setTimeout(()=>{
            this.$modal.show('noticeUpdatesForm');
        })
        
    },
    data: () => ({
        spouseExists:false,
        companyName:'',
        usciscNoticesUpdateError:'',
        loading:false,
        documentTypes:["Original" ,"Electronic" ],
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
        },
        uscisstatuslist: [
            {
                value: "USCIS_APPROVED",
                text: "Case Approved",
                id:'USCIS_APPROVED',
                name:"Case Approved",
            },
            {
                value: "USCIS_RECEIVED_RFE",
                text: "RFE Received",
                id:'USCIS_RECEIVED_RFE',
                name:"RFE Received",
            },
            {
                value: "USCIS_DENIED",
                text: "Case Denied",
                id:'USCIS_DENIED',
                name:"Case Denied",
            },
            {
                value: "USCIS_WITHDRAWN",
                text: "Case Withdrawn",
                id:'USCIS_WITHDRAWN',
                name:"Case Withdrawn",
            },
        ],
        isAlreadyUpdated:false,
        selectedCategory:'',
        selectedAction:'',
        selectedNoticeData:{
            documents:[],
            userType:'',
            userName:'',
            receivedDate:null,
            issuedDate:null,
            dueDate:null,
            action:null,
            description:''
        },
        receiptDataList:[],
        benSelected:false,
        isH1bCase:false,
        isL1Case:false,
        isL2Case:false,
        isH4Case:false,
        selectedReturnObj:null,
    }),
    props: { 
        documentDetail: {
            type: Object,
            default: null,
        },
        aiReqCronId: {
            type: String,
            default: null,
        },
        ACTIVITYCODE: {
            type: String,
            default: null,
        },
        petition: {
            type: Object,
            default: null,
        },
        caseCurrentDetails:{
            type: Array,
            default: []
        },
    },
    computed:{
        checkRFECase(){
            let returnVal = false;
            if(this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length') >0
            && (this.petition.completedActivities.indexOf('RFE_PREPARE_RESPONSE_DOCS') >-1 || (this.petition.completedActivities.indexOf('RFE_USCIS_APPROVED') > -1 || 
            this.petition.completedActivities.indexOf('RFE_USCIS_RECEIVED_RFE') > -1 
            || this.petition.completedActivities.indexOf('RFE_USCIS_DENIED') > -1
            || this.petition.completedActivities.indexOf('RFE_USCIS_WITHDRAWN') > -1))){
                returnVal = true
            }
            return returnVal
        },
        checkSectionVal(){
            return(code='')=>{
                let returnVal = null;
                if(code){
                    returnVal = _.find( this.receiptDataList, {'type':code });
                }
                return returnVal;
            }
        },
        
    }
  };
  </script>
  